<template>
    <div id="preview"> 
        <div class="app-inner">
             <div class="public-btn-small flex align-cen posta enposta">
            <div class="public-btn-small-plan"  @click="$util.reback('/teacheManage/questionList')" style="margin-left:0">
                返回
            </div>
            </div>
                   <div class="preview-content">
               <div class="portlet">
                <!-- <div class="portlet-head flex align-cen">
            <div class="caption">试题{{Number($route.query.index)+1}}/{{$route.query.length}}</div>
        </div> -->
        <div class="portlet-body">
            <div class="duplication-info-container">
                 <div class="ques-title flex align-cen">
                <span class="ques-type">
                        {{num}}/{{$route.query.length}}
                         {{$util.getTopicType(detailInfo.type)}}
                </span>
                <div class="qcotent flex align-cen">
                   <p v-html="detailInfo.title" :class="detailInfo.type == 9 ? 'clozeClass' : ''"></p>
                    <AudioTem :audioSrc="audioPro" v-if="audioPro">

                    </AudioTem>
                </div>
                <div class="ques-score">
                    ({{detailInfo.score}}分)
                </div>
            </div>
             <div class="question-option-list">
                    <ol v-if="detailInfo.type != 9 && detailInfo.type != 5">
                        <li v-for="(sonitem,sonIndex) in detailInfo.answerList">
                            <p v-html="sonitem.content"></p>
                        </li>
                    </ol>
                    <div class="refAnswer" style="margin-left:-25px" v-if="detailInfo.type == 5">
                        <div class="detailKeyWorld" v-if="detailInfo.rule">
                           <div class="flex align-cen" style="font-size:16px;color:#999;padding:10px 0">
                            <p>关键字：</p>
                             <p v-for="(item,index) in detailInfo.answerList">
                                {{item.content}}<span v-if="index !=detailInfo.answerList.length-1">，</span>
                            </p>
                           </div>
                        </div>
                        <div class="detailKeyWorld" v-else style="font-size:16px;color:#999;padding:10px 0">关键字:无</div>
                    </div>
                   <div class="clzoe" v-if="detailInfo.type == 9">
                     <div class="clzoeItem" v-for="(item,index) in detailInfo.answerList" :key="index">
                        <p class="cloze-op-p">
                           <strong> {{index + 1}}:</strong>
                        </p>
                        <ol style="margin-left:20px">
                            <li  v-for="(sonitem,sonIndex) in detailInfo.answerList[index].clozeList" :key="sonIndex">
                                <p v-html="sonitem.content"></p>
                            </li>
                        </ol>
                         <p style="color:rgb(153, 153, 153)">解析：{{item.content}}</p>
                     </div>
                   </div>
                </div>
                    <div class="ques-answers">
        <div class="test_result">
            <div class="rightAnswer flex">
                <span v-if="detailInfo.type != 7 && detailInfo.type != 9 && detailInfo.type != 5">
                    正确答案：
                    <span v-for="(sonitem,sonIndex) in detailInfo.answerList">
                        <span  v-if="sonitem.isRight == 1">
                        {{Eng[sonIndex]}}
                    </span>
                    </span>
                </span>
                <span v-if="detailInfo.type == 5" class="flex align-cen" style="color:#009aff">
                    参考答案：
                    <span v-html="detailInfo.refAnswer"></span>
                </span>
                 <span v-if="detailInfo.type == 7">
                    正确顺序：
                    <span v-for="(sonitem,sonIndex) in sortedIndexes">
                        <span>
                        {{Eng[sonitem]}}
                    </span>
                    </span>
                </span>
                <span v-if="detailInfo.type == 9">
                    正确答案：
                    <span v-for="(item,index) in detailInfo.answerList">
                                <span style="margin-right:20px">
                                {{index + 1}}:
                                <span v-for="(sonitem,sonIndex) in detailInfo.answerList[index].clozeList" :key="sonIndex">
                                    <span v-if="sonitem.isRight == 1">{{Eng[sonIndex]}}</span>
                                </span>
                                </span>
                    </span>
                </span>
            </div>
               <div class="analysiCon flex align-cen">
                <span class="label">题目解析：</span>
                <span class="text" v-html="detailInfo.analysis"></span>
               </div>
                 <div class="infoCon flex align-cen" style="color:#999;margin-top:20px;font-size:12px">
                    <span>分类：{{detailInfo.classifyName}}</span> 
                    <span style="margin:0 10px">|</span>
                     <span>标签：{{detailInfo.tag}}</span>
                 </div>
        </div>
    </div>
            </div>
        </div>
                </div>
                <div class="public-tit flex align-cen" style="margin:20px 10px">
            <div class="public-tit-list">
                <i class="icon-al-copy-fill"></i>  已使用试卷
            </div>
        </div>
        <div class="businessList-container">
     <div class="businessList-container-table">
                    <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%"
          border
          id='mytable'
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"
        >
        <el-table-column   label="序号" align="center" >
               <template slot-scope="scope">
              <p>{{scope.$index + 1}}</p>
            </template>
          </el-table-column>
         <el-table-column  prop="id" label="试卷ID" align="center" >
          </el-table-column>
          <el-table-column prop="paperName" label="试卷名称" align="center">
          </el-table-column>
              <el-table-column prop="createBy" label="作者" align="center">
          </el-table-column>
           <el-table-column prop="examNum" label="考试次数" align="center">
          </el-table-column>
       </el-table>
        </div>
        </div>
        </div>
        </div>
    </div>
</template>
<script>
import { getEnQuestion,getPaperList} from "@/api/enterprise/index"; // 题目详情
import mycomponents from "../../../utils/compoments.js"
export default {
    components: {
    AudioTem: mycomponents.components.PublicAudio,
  },
    data () {
        return {
            audioSrc:'',
             Eng:['A','B','C','D','E','F','G','H','I','J'],
            detailInfo:{},
            list:[],
            businessInfo:{},
             sortedIndexes:[]
        }
    },
    created () {
            let a = Number((this.$route.query.current)-1)
        let b = Number(this.$route.query.index)+1
        this.num =  JSON.stringify(a) + JSON.stringify(b)
        this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        this.getQuestionInfo()
    },
    methods: {
        getQuestionInfo(){
            getEnQuestion({id:this.$route.query.id,businessId:this.businessInfo.id},'get','enterprise').then(res => {
               this.detailInfo = res.data
               this.audioPro = res.data['audio']
                   if(res.data.type == 9){
                    this.detailInfo.answerList.forEach((t,index) => {
                          let patternString = `{{${index + 1}}}`;
                          this.detailInfo.title = this.detailInfo.title.replace(patternString, `__${index + 1}__`)
                    })  
                }
                if(res.data.type == 7){
                    // 创建一个包含原数组索引和值的数组  
                        let indexedArray = this.detailInfo.answerList.map((item, index) => ({ item, index }));  
                        // 根据sort值进行排序  
                        indexedArray.sort((a, b) => a.item.sort - b.item.sort);  
                        console.log(indexedArray)     
                        // 提取排序后的索引  
                        this.sortedIndexes = indexedArray.map(item => item.index);  
                }
               this.getQuestionList(res.data.id)
            })
        },
        getQuestionList(questionId){
              let params = {
                paperName:'',
                id:'',
                classifyId:'',
                state:'',
                validPeriod:'',
                questionId:questionId,
                current: 1,
                size:1000,
                businessId:this.businessInfo.id
            }
             getPaperList(params)
            .then(res =>{
               this.list = res.data.records
            })
            .catch(err =>{})
        },
    }
}
</script>
<style lang="scss" scoped>
#preview{
    margin-bottom: 70px;
}
.preview-content{
    position: relative;
    .portlet{
    background: #fafafa;
    padding: 16px 10px !important;
    border-radius: 5px;
     width: 98%;
    .portlet-head{
     border-bottom: 0;
    padding: 0 10px;
    margin-bottom: 0;
    color: #fff;
    }
                         .portlet-body{
                            padding: 10px;
                            .duplication-info-container{
                                .ques-title {
                                    position: relative;
                                    padding-right: 50px;
                                    font-size: 17px;
                                    vertical-align: middle;
                                    line-height: 1.5;
                                    -webkit-margin-before: 0;
                                    -webkit-margin-after: 0;
                                    word-break: break-word;
                                    .ques-type{
                                      background-color: #387dfe;
                                        color: #fff;
                                        padding: 3px 12px;
                                        border: none;
                                        font-size: 12px;
                                        width: 120px;
                                        text-align: center;
                                    }
                                    .qcotent{
                                        padding: 0 10px;
                                        font-size: 15px;
                                    }
                                    .ques-score{
                                        position: absolute;
                                        top: 0px;
                                        right: 10px;
                                        color: #000;
                                    }
                                }
                                .question-option-list{
                                    padding: 0 20px;
                                    margin-top: 10px;
                                    li{
                                        list-style-type: upper-latin;
                                        margin-bottom: 15px;
                                        font-size: 14px;
                                    }
                                    li::marker{
                                       unicode-bidi: isolate;
                                    font-variant-numeric: tabular-nums;
                                    text-transform: none;
                                    text-indent: 0px !important;
                                    text-align: start !important;
                                    text-align-last: start !important; 
                                    }
                                }
                                .ques-answers{
                                    .test_result{
                                        margin-bottom: 8px;
                                       .rightAnswer{
                                            display: block;
                                       } 
                                    }
                                }
                            }
                        }
    }
}
::v-deep{
  .clozeClass{
    p{
        display: inline-block !important;
      }
  }
}
</style>